import { makeStyles } from '@material-ui/core/styles'
import { BreadCrumbLink, BreadCrumbLinkActive } from '../../../utils/colors'

export const useStyles = makeStyles((theme) => ({
  BreadCrumbContainer: {
    position: 'relative',
    zIndex: 10,
    padding: theme.spacing(0, 1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    backgroundColor: theme.palette.common.white,
    '& .MuiBreadcrumbs-separator svg': {
      transform: theme.direction === 'ltr' ? 'scaleX(1)' : 'scaleX(-1)'
    },
    '& a': {
      padding: theme.spacing(1.25),
      color: BreadCrumbLink,
      fontWeight: theme.typography.fontWeightBold,
      '& svg': {
        verticalAlign: 'bottom'
      }
    }
  },
  BreadCrumbActiveLink: {
    padding: theme.spacing(1.25),
    color: BreadCrumbLinkActive,
    fontWeight: theme.typography.fontWeightBold
  }
}))
